import validator from 'validator';
import {useContext} from 'react';
import {I18nReactContext} from '../../contexts/I18nContext';

// Define patterns to check for
const sqlInjectionPatterns = ['SELECT', 'INSERT', 'UPDATE', 'DELETE', 'DROP', 'UNION', 'WHERE', 'FROM'];
const xssPatterns = ['<script>', 'javascript:', 'onerror', 'onload'];
const commandInjectionPatterns = [';', '&&', '||', '|', '>', '<'];

/**
 * Hook that provides input validation functions with i18n support
 * @returns {object} Object containing validation functions
 */
export const useInputValidation = () => {
    const {i18n} = useContext(I18nReactContext);
    
    /**
     * Validates input for security threats
     * @param {object} params - The function parameters
     * @param {string} params.input - The input string to validate
     * @returns {string} The validated input
     * @throws {Error} If input is invalid or contains security threats
     */
    const validateInput = ({input}) => {
        if (!input || typeof input !== 'string') {
            throw new Error(String(i18n.translate('general.invalidInput')));
        }
        
        // Check for SQL injection patterns
        for (const pattern of sqlInjectionPatterns) {
            if (input.includes(pattern)) {
                throw new Error(String(i18n.translate('errors.invalidInput', { context: { pattern } })));
            }
        }

        // Check for XSS patterns
        for (const pattern of xssPatterns) {
            if (input.includes(pattern)) {
                throw new Error(String(i18n.translate('errors.invalidInput', { context: { pattern } })));
            }
        }

        // Check for command injection patterns
        for (const pattern of commandInjectionPatterns) {
            if (input.includes(pattern)) {
                throw new Error(String(i18n.translate('errors.invalidInput', { context: { pattern } })));
            }
        }

        return input;
    };
    
    return {
        validateInput
    };
};